import { locales } from '../config';

export function convert(base, rates, amount, from, to) {
    if (rates[from]) return ((amount / rates[from]) * rates[to || base]);
    return 0;
}

export function manualCurrencyConversion({ amount, fromPrice, toPrice }) {
    if (!fromPrice) return amount;
    return Number((amount * (toPrice / fromPrice)).toFixed(2));
}

export function getCurrencySymbol(currency, locale) {
    let defaultValue = 0;
    let convertCurrency = currency ? currency : 'USD';
    let symbol = defaultValue.toLocaleString(locales[0], { style: 'currency', currency: convertCurrency, minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/\d+([,.]\d+)?/g, "") || null;
    return symbol;
}